import { render, staticRenderFns } from "./cardBase.vue?vue&type=template&id=15beb356&"
import script from "./cardBase.vue?vue&type=script&lang=js&"
export * from "./cardBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports